import { UseMutationResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'

import { AuthFetchError } from '@e3dc-react/shell/Types'
import { uploadAmazonCard } from '../apis'
import { AmazonGiftCardUploadingResultDto } from '../apis/dto/amazon-codes.dto'

interface UseAmazonGiftCardUploadingParams {
  onSuccess?: (result: AmazonGiftCardUploadingResultDto | null, vars: UseAmazonGiftCardUploadingVariables) => void
  onError?: (error: AuthFetchError, vars: UseAmazonGiftCardUploadingVariables) => void
}

interface UseAmazonGiftCardUploadingVariables {
  payload: FormData
}

type UseAmazonGiftCardUploading = (
  data: UseAmazonGiftCardUploadingParams
) => UseMutationResult<AmazonGiftCardUploadingResultDto | null, AuthFetchError, UseAmazonGiftCardUploadingVariables>

export const useAmazonGiftCardUploading: UseAmazonGiftCardUploading = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalMutation<AmazonGiftCardUploadingResultDto, AuthFetchError, UseAmazonGiftCardUploadingVariables>({
    mutationFn: (vars: UseAmazonGiftCardUploadingVariables) => uploadAmazonCard(vars.payload, authFetch),
    onSuccess: (data, vars) => onSuccess?.(data, vars),
    onError: (error: AuthFetchError, vars) => onError?.(error, vars),
  })
}
